<template>
  <div class="size-selector">
    <label
      v-for="opt in options"
      :key="opt.value"
      class="size-chip"
      :class="{ 'size-chip--checked': modelValue.includes(opt.value) }"
    >
      <input
        type="checkbox"
        :value="opt.value"
        :checked="modelValue.includes(opt.value)"
        @change="toggle(opt.value)"
      />
      <span class="size-chip__label">{{ opt.label }}</span>
      <span class="size-chip__hint">{{ opt.hint }}</span>
    </label>
  </div>
</template>

<script>
import { ICO_SIZES } from '../constants.js';

export default {
  name: 'SizeSelector',
  props: {
    modelValue: { type: Array, required: true },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      options: ICO_SIZES.map((s) => ({
        value: s,
        label: `${s} × ${s}`,
        hint: s === 256 ? '高清' : '标准',
      })),
    };
  },
  methods: {
    toggle(value) {
      const set = new Set(this.modelValue);
      if (set.has(value)) set.delete(value);
      else set.add(value);
      // Emit sorted numeric list.
      this.$emit('update:modelValue', Array.from(set).sort((a, b) => a - b));
    },
  },
};
</script>

<style lang="less" scoped>
.size-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.size-chip {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--bg-elev-2);
  color: var(--text);
  cursor: pointer;
  user-select: none;
  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;

  input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  &:hover {
    border-color: var(--accent);
  }

  &--checked {
    border-color: var(--accent);
    background: rgba(255, 122, 26, 0.15);
    color: var(--accent);

    .size-chip__hint {
      color: var(--accent);
    }
  }

  &__label {
    font-size: 14px;
    font-weight: 500;
  }

  &__hint {
    font-size: 12px;
    color: var(--text-dim);
  }
}
</style>
